import { useTranslation } from 'react-i18next';
import type { IObserverBannerProps } from './IObserverBannerProps';

/** Банер режиму спостерігача (прототип v4 isObserver): «Режим спостерігача · <ім'я> · лише перегляд» і жовта «Змінити особу» внизу по центру. */
export function ObserverBanner({ name, busy, onSwitch }: IObserverBannerProps) {
  const { t } = useTranslation();
  return (
    <div className="obs-banner" role="status">
      <strong>{t('observer.title')}</strong>
      <span className="obs-banner__who">{t('observer.readOnly', { name })}</span>
      <button type="button" className="obs-banner__switch" disabled={busy} onClick={onSwitch}>{t('observer.switch')}</button>
    </div>
  );
}
